export default "__VITE_ASSET__54332fb5__"